import { render, staticRenderFns } from "./List-Dashboard.vue?vue&type=template&id=43d94b50&scoped=true"
import script from "./List-Dashboard.vue?vue&type=script&lang=js"
export * from "./List-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./List-Dashboard.vue?vue&type=style&index=0&id=43d94b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d94b50",
  null
  
)

export default component.exports